// src/pages/dashboard/topBar/NotificationBell.jsx
import React, { Component, createRef } from 'react';
import { Link } from 'react-router-dom';

export default class NotificationBell extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.ref = createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleKey = this.handleKey.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.handleItemClick = this.handleItemClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('keydown', this.handleKey);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKey);
  }

  handleClickOutside(e) {
    if (this.ref.current && !this.ref.current.contains(e.target)) {
      this.setState({ open: false });
    }
  }

  handleKey(e) {
    if (e.key === 'Escape' && this.state.open) {
      this.setState({ open: false });
    }
  }

  toggleOpen() {
    this.setState(prev => ({ open: !prev.open }));
  }

  handleItemClick(id) {
    const { onMarkRead } = this.props;
    if (onMarkRead) onMarkRead(id);
    this.setState({ open: false });
  }

  render() {
    const {
      count = 0,
      items = [],
      onRemove,
      onClearAll,
      onMarkRead,
      onMarkAllRead,
      viewAllHref, // optional: pass "/home/notifications" if/when you add that route
    } = this.props;

    const { open } = this.state;

    return (
      <div className="topbar-item" ref={this.ref}>
        <button
          className="icon-btn"
          aria-label="Notifications"
          aria-expanded={open}
          aria-haspopup="menu"
          onClick={this.toggleOpen}
          type="button"
        >
          <span className="bell" aria-hidden>
            <svg
              className="bell-icon"
              viewBox="0 0 24 24"
              width="20"
              height="20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 18H9M18 16V11C18 8.23858 15.7614 6 13 6H11C8.23858 6 6 8.23858 6 11V16L4.5 17.5V18H19.5V17.5L18 16Z"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 18C10 19.1046 10.8954 20 12 20C13.1046 20 14 19.1046 14 18"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
              />
            </svg>
          </span>
          {count > 0 && (
            <span className="badge" aria-label={`${count} unread`}>{count}</span>
          )}
        </button>

        {open && (
          <div className="dropdown panel notifications-panel" role="menu">
            <div className="dropdown-header">
              <span>Notifications</span>
              {items.length > 0 && (
                <div className="dropdown-actions">
                  <button
                    className="link small"
                    type="button"
                    onClick={() => onMarkAllRead && onMarkAllRead()}
                  >
                    Mark all read
                  </button>
                  <span className="sep">·</span>
                  <button
                    className="link small danger"
                    type="button"
                    onClick={() => onClearAll && onClearAll()}
                  >
                    Clear all
                  </button>
                </div>
              )}
            </div>

            {items.length === 0 ? (
              <div className="dropdown-empty">You’re all caught up.</div>
            ) : (
              <ul className="dropdown-list">
                {items.map((n, i) => {
                  const key = n.id || i;
                  const hasRoute = !!n.route;
                  // Build href like "/home/decorate?job=abc123"
                  const search = n.query ? `?${new URLSearchParams(n.query).toString()}` : '';
                  const href = hasRoute ? `${n.route}${search}` : null;

                  return (
                    <li key={key} className="dropdown-item" role="menuitem">
                      {hasRoute ? (
                        <Link
                          to={href}
                          className="notif-main"
                          onClick={() => this.handleItemClick(n.id)}
                        >
                          <div className="notif-title">
                            {!n.read && <span className="dot" aria-hidden />}
                            {n.title}
                          </div>
                          {n.time && <div className="notif-meta">{n.time}</div>}
                        </Link>
                      ) : (
                        <div className="notif-main">
                          <div className="notif-title">
                            {!n.read && <span className="dot" aria-hidden />}
                            {n.title}
                          </div>
                          {n.time && <div className="notif-meta">{n.time}</div>}
                        </div>
                      )}

                      <div className="notif-actions">
                        {!n.read && (
                          <button
                            className="link small"
                            type="button"
                            onClick={() => onMarkRead && onMarkRead(n.id)}
                            aria-label="Mark as read"
                            title="Mark as read"
                          >
                            Mark read
                          </button>
                        )}
                        <button
                          className="link small danger"
                          type="button"
                          onClick={() => onRemove && onRemove(n.id)}
                          aria-label="Remove notification"
                          title="Remove"
                        >
                          Remove
                        </button>
                      </div>
                    </li>
                  );
                })}
              </ul>
            )}

            {viewAllHref ? (
              <div className="dropdown-footer">
                <Link to={viewAllHref} className="link">View all</Link>
              </div>
            ) : null}
          </div>
        )}
      </div>
    );
  }
}
